import React from 'react';
import { useController, useFormContext } from 'react-hook-form';
import useFormName from '../../Hooks/useFormName';
import ErrorMessage from '../Form/components/ErrorMessage';
import { useValidation } from '../Utils/Validation';
import PhoneNumberInput from './PhoneNumberInput';
import TopFieldContent from '../Form/components/TopFieldContent';
import InputWrapper from '../Form/components/InputWrapper/InputWrapper';

interface PhoneNumberFieldProps {
	name: string;
	label?: string;
	isRequired?: boolean;
	className?: string;
	onChange?: (phoneNumber: string) => void;
	disabled?: boolean;
	isWrapped?: boolean;
}

const PhoneNumberField: React.FC<PhoneNumberFieldProps> = ({
	name,
	label,
	className,
	isRequired,
	disabled,
	isWrapped,
}) => {
	const { fieldName } = useFormName({ name });
	const { control } = useFormContext();

	const {
		field,
		fieldState: { error },
	} = useController({
		control,
		name: fieldName,
	});

	const component = (
		<div className={className}>
			{label && <TopFieldContent label={label} isRequired={isRequired} />}
			<PhoneNumberInput {...field} disabled={disabled} />
			{error?.message && <ErrorMessage tx={error.message} />}
		</div>
	);

	if (isWrapped) {
		return <InputWrapper>{component}</InputWrapper>;
	}

	return component;
};

export default PhoneNumberField;
